import { useCallback, useEffect, useRef } from 'react';
import { systemAlert } from 'shared/src/component';
import { useInstanceId } from 'shared/src/hooks';
import { useGoodsBasic } from '../queries/useGoodsBasic';
import { useNavigation } from '@react-navigation/native';
import { bridge } from 'shared/src/utils';

// STOP_SALE 상품은 진입 즉시 안내 후 이전 화면으로 복귀시킨다.
// SOLD_OUT 등 다른 sale_type은 현행 유지.
export const useStopSaleGuard = () => {
  const { data: basic } = useGoodsBasic();
  const instanceId = useInstanceId();
  const navigation = useNavigation();

  const hasAlertedRef = useRef(false);

  const isStopSale = basic?.sale_type === 'STOP_SALE';

  const onPressConfirm = useCallback(() => {
    if (!instanceId) {
      return;
    }

    const canGoBack = navigation.canGoBack();

    if (canGoBack) {
      navigation.goBack();
      return;
    }
    bridge.closeInstance({ instanceId });
  }, [instanceId, navigation]);

  useEffect(() => {
    if (!isStopSale || hasAlertedRef.current) return;
    hasAlertedRef.current = true;

    systemAlert('판매 중인 상품이 아닙니다', undefined, [
      { text: '확인', onPress: onPressConfirm },
    ]);
  }, [isStopSale, onPressConfirm]);
};
